import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'
import type { EmailStatus } from '@/types/api'

/**
 * Farba stavu nesie odkaz, nie ozdobu.
 *
 * Zelená je len `delivered` — teda „server príjemcu to prevzal“. `sent`
 * zostáva modré, pretože znamená iba to, že správu prevzal poskytovateľ;
 * práve tento rozdiel je dôvod, prečo sa e-maily strácali bez stopy.
 */
export const STATUS_STYLES: Record<EmailStatus, string> = {
  queued: 'bg-slate-100 text-slate-700',
  sending: 'bg-amber-100 text-amber-800',
  sent: 'bg-blue-100 text-blue-800',
  delivered: 'bg-green-100 text-green-800',
  bounced: 'bg-red-100 text-red-800',
  failed: 'bg-red-100 text-red-800',
  cancelled: 'bg-slate-100 text-slate-500',
}

/** Poradie v prepínači - podľa toho, ako často to niekto hľadá. */
export const STATUS_ORDER: EmailStatus[] = [
  'queued',
  'sending',
  'sent',
  'delivered',
  'bounced',
  'failed',
  'cancelled',
]

export function StatusBadge({
  status,
  className,
}: {
  status: EmailStatus
  className?: string
}) {
  const { t } = useTranslation()
  return (
    <span
      className={cn(
        'whitespace-nowrap rounded px-1.5 py-0.5 text-xs font-medium',
        STATUS_STYLES[status] ?? 'bg-slate-100 text-slate-700',
        className,
      )}
    >
      {t(`emails.status.${status}`)}
    </span>
  )
}
